import type { Session } from "@supabase/supabase-js";
import { supabase } from "./supabaseClient";
import { idbPersister, queryClient } from "./queryClient";

export async function dangNhapGoogle(): Promise<void> {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: { redirectTo: window.location.origin },
  });
  if (error) throw error;
}

export async function dangXuat(): Promise<void> {
  await supabase.auth.signOut();
}

export function theoDoiPhien(callback: (session: Session | null) => void): () => void {
  supabase.auth.getSession().then(({ data }) => callback(data.session));
  const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
    if (event === "SIGNED_OUT") {
      queryClient.clear();
      void idbPersister.removeClient();
    }
    callback(session);
  });
  return () => sub.subscription.unsubscribe();
}
